import { FileEditorRef } from "@/components/fileEditor";
/**
 * A singleton service that manages a map of file paths to their corresponding editor references.
 */
export class FileEditorMapService {
    private static instance: FileEditorMapService;
    private fileEditorMap: Map<string, FileEditorRef>;

    private constructor() {
        this.fileEditorMap = new Map<string, FileEditorRef>();
    }

    public static initialize() { 
        FileEditorMapService.instance = new FileEditorMapService();
     }

    /**
     * Gets the singleton instance of the service.
     */
    public static getInstance(): FileEditorMapService {
        if (!FileEditorMapService.instance) {
            this.initialize();
        }
        return FileEditorMapService.instance;
    }

    /**
     * Sets a file editor reference for a given path.
     * @param path The file path
     * @param ref The editor reference
     */
    public setEditorRef(path: string, ref: FileEditorRef): void {
        this.fileEditorMap.set(path, ref);
    }

    /**
     * Gets a file editor reference for a given path.
     * @param path The file path
     * @returns The editor reference or undefined if not found
     */
    public getEditorRef(path: string): FileEditorRef | undefined {
        return this.fileEditorMap.get(path);
    }

    /**
     * Deletes a file editor reference for a given path.
     * @param path The file path
     * @returns True if the editor reference was deleted, false otherwise
     */
    public deleteEditorRef(path: string): boolean {
        return this.fileEditorMap.delete(path);
    }

    /**
     * Clears all editor references.
     */
    public clearAll(): void {
        this.fileEditorMap.clear();
    }

    /**
     * Gets all paths with editor references.
     * @returns Array of paths
     */
    public getAllPaths(): string[] {
        return Array.from(this.fileEditorMap.keys());
    }
}